module.exports = __webpack_public_path__ + "static/media/nivel 3_400.32f1499b.jpg";